import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=663f3499&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('663f3499')) {
      api.createRecord('663f3499', component.options)
    } else {
      api.reload('663f3499', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=663f3499&", function () {
      api.rerender('663f3499', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2U8q6LTOagjIH/JS/pricehelp.vue"
export default component.exports